
export default () => {
  if (navigator) {
    return navigator.maxTouchPoints > 0;
  }
  return false;
};
